import React, { FC, useEffect, useState } from 'react'

import AdminIcon from '@mui/icons-material/Security'
import ContactSupportIcon from '@mui/icons-material/ContactSupport'

import SubMenu, { MenuItem, SubMenuWithResourcesProps } from 'dash/layout/menu/sub_menu'

type ServicesMenuProps = SubMenuWithResourcesProps

export const ServicesMenu: FC<ServicesMenuProps> = ({ dense, onMenuClick, resources, sidebarIsOpen }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [menuItems, setMenuItems] = useState<MenuItem[]>([])

  useEffect(() => {
    if (resources) {
      const menuItems: MenuItem[] = [
        ...resources,
        // {
        //   name: 'Helpdesk',
        //   route: '/account/:account_id/services/helpdesk',
        //   icon: ContactSupportIcon,
        // },
      ]
      setMenuItems(menuItems)
    }
  }, [resources])

  return (
    <SubMenu
      dense={dense}
      flatten
      handleToggle={() => setIsOpen(!isOpen)}
      icon={<AdminIcon />}
      // isOpen={isOpen}
      isOpen
      menuItems={menuItems}
      name="Services"
      onMenuClick={onMenuClick}
      sidebarIsOpen={sidebarIsOpen}
      subMenuKey="services"
    />
  )
}
